import { Country } from '../country/country';

// October 1, 2026 at 00:00 America/Los_Angeles (PDT, UTC−07:00).
export const SEPTEMBER_CREDIT_EXPIRES_AT = '2026-10-01T07:00:00Z';

// Campaign policy: fixed BMSM $10 amounts, not exchange-rate conversions.
export const SEPTEMBER_CREDIT_AMOUNTS = {
  [Country.UnitedStates]: 10,
  [Country.Australia]: 10,
  [Country.NewZealand]: 10,
  [Country.Canada]: 10,
  [Country.UnitedKingdom]: 8,
  [Country.Singapore]: 10,
  [Country.Malaysia]: 50,
  [Country.UnitedArabEmirates]: 40,
  [Country.SaudiArabia]: 40,
  [Country.Netherlands]: 10,
  [Country.Belgium]: 10,
  [Country.Germany]: 10,
  [Country.France]: 10,
  [Country.Poland]: 40,
  [Country.Kazakhstan]: 5400,
  [Country.Mongolia]: 32000,
  [Country.Azerbaijan]: 16,
  [Country.Switzerland]: 8,
  [Country.Denmark]: 70,
  [Country.Norway]: 100,
  [Country.Japan]: 1500,
  [Country.Mexico]: 200,
  [Country.Chile]: 10000,
  [Country.Colombia]: 40000,
} satisfies Record<Country, number>;
